export default __webpack_public_path__ + "static/media/elsass.835ce2b9.svg";